import { ImageData, ProcessedImageData, ThresholdOptions } from './esc-pos-image.types';

/**
 * Apply threshold dithering to an image
 * Converts pixels to pure black or white based on luminance threshold
 * @param imageData Input image data
 * @param options Threshold options with threshold value (0-255)
 * @returns Processed black and white image data
 */
export function threshold(
  imageData: ImageData,
  options: ThresholdOptions = { threshold: 128 },
): ProcessedImageData {
  const { data, width, height } = imageData;
  const { threshold: thresholdValue } = options;

  const processedData = new Uint8ClampedArray(data.length);

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const alpha = data[i + 3];

    // Calculate luminance using standard RGB to grayscale conversion
    // Luminance = 0.299*R + 0.587*G + 0.114*B
    const luminance = Math.round(0.299 * r + 0.587 * g + 0.114 * b);

    // Apply threshold: if luminance is above threshold, make it white (255), otherwise black (0)
    const pixelValue = luminance >= thresholdValue ? 255 : 0;

    // Set RGB channels to the same value (black or white)
    processedData[i] = pixelValue; // Red
    processedData[i + 1] = pixelValue; // Green
    processedData[i + 2] = pixelValue; // Blue
    processedData[i + 3] = alpha; // Keep original alpha
  }

  return {
    data: processedData,
    width,
    height,
  };
}
